module.exports = __webpack_public_path__ + "media/device_images/macbook_bijan-b96a2752.svg";